 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-01347eea":"5d37956e","chunk-0232e452":"478c5580","chunk-1151d6d2":"53e07650","chunk-222a1108":"0815148e","chunk-1ca8281b":"2d75ce6b","chunk-1259bed9":"2d471f42","chunk-2cb63e3a":"945fc268","chunk-1a753740":"ba74d8df","chunk-2d2172bd":"503d9680","chunk-10b587b9":"1bb482bd","chunk-2fefc2ba":"d6d96781","chunk-375c8d73":"aa166a36","chunk-29bebfab":"abd42e1b","chunk-2d0a3159":"b169c8b0","chunk-2d0dd7af":"ea3dcbd1","chunk-2d0ddba1":"dcc4ca0b","chunk-2d20864f":"55847af0","chunk-2d22b970":"5b57e835","chunk-2d21a841":"e51d5ed1","chunk-2d237ffc":"ab605b15","chunk-4ef50286":"1ee40762","chunk-4442e952":"841b47ba","chunk-4e69cf76":"1489f175","chunk-50d21eb3":"d65647eb","chunk-57cc81a2":"7d2e192b","chunk-5c4c15db":"d5b1e754","chunk-00978fa7":"850a510d","chunk-df2ead5c":"7fbaa38f","chunk-08a87dc8":"1373d833","chunk-2d0aa281":"0d842714","chunk-25352464":"e2cae5aa","chunk-2d0ae5d6":"1b521dc0","chunk-2d0da355":"c4ae173e","chunk-2d216ba8":"5bdf7773","chunk-b57fc804":"7b9fdfba","chunk-5cc1684b":"27f6347d","chunk-68d1576d":"931efeae","chunk-69505e62":"3eca9ac7","chunk-4319630e":"b066209c","chunk-348c457e":"2d4099dc","chunk-d4a1374e":"f62279ca","chunk-17829288":"1510781c","chunk-46cbb527":"71485431","chunk-560cd510":"710f0834","chunk-56e47990":"d2dadeb9","chunk-3d494bb4":"942044d2","chunk-2191ace6":"831569c5","chunk-2751310e":"825aac3b","chunk-2d22693c":"f55199ed","chunk-7c6c5868":"395c9e60","chunk-f5d0d6bc":"80e571ea","chunk-fc733508":"63a3d7c0","chunk-2d22d3f4":"7a5cfb55","chunk-b932986e":"9896a9d8","chunk-6f197e96":"c1827a11","chunk-889f54bc":"4bec57d0","chunk-a9632ad4":"3728b423","chunk-b815aa6c":"a0543510","chunk-ddbd689a":"4dd61dc8","chunk-26f209f6":"cb71fe8b","chunk-ecae29fc":"bf771500","chunk-f8432fd6":"df6f4445","chunk-ffeae3ca":"dd2890b4","chunk-10d582ee":"137917c0","chunk-1d94d3f1":"5bc3a64e","chunk-2d0cc2ee":"484cff5c","chunk-3e2e8798":"189921d0","chunk-401d5cd2":"76f3e5db","chunk-2cf0b788":"2876448d","chunk-e0125934":"9a28d630","chunk-0735384e":"fc19ed62","chunk-743c2ddb":"a76340f5","chunk-7457c560":"de003d3e","chunk-745a3122":"a496ad2d","chunk-7467d5b8":"81acc37a","chunk-7482e5bc":"a45e4312","chunk-74af77ea":"72d835d8","chunk-74b7681c":"af3b4519","chunk-74bb0962":"1d1c34d4","chunk-76f042f8":"cf4c94f3","chunk-774c8cf7":"d2e748d9","chunk-17a63ea5":"f7f46f16","chunk-2d209b31":"54072f58","chunk-0987dada":"76d41ba2","chunk-6943e552":"397e2396","chunk-80018e16":"824c34e9","chunk-a1825bbc":"239f2da9","chunk-2d2223ef":"d1b18fd6","chunk-2d607d30":"b81baa82","chunk-2f83f030":"d232951b","chunk-4aad5e3d":"5e296feb","chunk-55693694":"5258da1a","chunk-62fe80ef":"4ceffac5","chunk-71fa889d":"c9a8da2c","chunk-7d47e309":"4b9d8ba1","chunk-037567df":"c63ae279","chunk-3bafb6c4":"38ed1f5e","chunk-ad1740b0":"930e12dd","chunk-ba57138a":"06518ac0","chunk-c0f817d4":"f6c80d39","chunk-f210cb80":"8723b4bd"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01347eea":1,"chunk-0232e452":1,"chunk-1151d6d2":1,"chunk-222a1108":1,"chunk-1ca8281b":1,"chunk-1259bed9":1,"chunk-2cb63e3a":1,"chunk-1a753740":1,"chunk-10b587b9":1,"chunk-2fefc2ba":1,"chunk-375c8d73":1,"chunk-29bebfab":1,"chunk-4ef50286":1,"chunk-4442e952":1,"chunk-4e69cf76":1,"chunk-50d21eb3":1,"chunk-57cc81a2":1,"chunk-5c4c15db":1,"chunk-08a87dc8":1,"chunk-25352464":1,"chunk-5cc1684b":1,"chunk-68d1576d":1,"chunk-69505e62":1,"chunk-4319630e":1,"chunk-348c457e":1,"chunk-d4a1374e":1,"chunk-17829288":1,"chunk-46cbb527":1,"chunk-560cd510":1,"chunk-56e47990":1,"chunk-3d494bb4":1,"chunk-2191ace6":1,"chunk-2751310e":1,"chunk-7c6c5868":1,"chunk-f5d0d6bc":1,"chunk-fc733508":1,"chunk-b932986e":1,"chunk-6f197e96":1,"chunk-889f54bc":1,"chunk-a9632ad4":1,"chunk-b815aa6c":1,"chunk-ddbd689a":1,"chunk-26f209f6":1,"chunk-ecae29fc":1,"chunk-f8432fd6":1,"chunk-ffeae3ca":1,"chunk-10d582ee":1,"chunk-1d94d3f1":1,"chunk-401d5cd2":1,"chunk-2cf0b788":1,"chunk-e0125934":1,"chunk-0735384e":1,"chunk-743c2ddb":1,"chunk-7457c560":1,"chunk-745a3122":1,"chunk-7467d5b8":1,"chunk-7482e5bc":1,"chunk-74af77ea":1,"chunk-74b7681c":1,"chunk-74bb0962":1,"chunk-76f042f8":1,"chunk-774c8cf7":1,"chunk-17a63ea5":1,"chunk-0987dada":1,"chunk-6943e552":1,"chunk-80018e16":1,"chunk-a1825bbc":1,"chunk-2d607d30":1,"chunk-2f83f030":1,"chunk-4aad5e3d":1,"chunk-55693694":1,"chunk-62fe80ef":1,"chunk-71fa889d":1,"chunk-037567df":1,"chunk-3bafb6c4":1,"chunk-ad1740b0":1,"chunk-ba57138a":1,"chunk-c0f817d4":1,"chunk-f210cb80":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-01347eea":"1eddce2c","chunk-0232e452":"e4bde69a","chunk-1151d6d2":"cee4c07f","chunk-222a1108":"56fe509a","chunk-1ca8281b":"0bb5e88d","chunk-1259bed9":"bc3c400f","chunk-2cb63e3a":"7de0dee6","chunk-1a753740":"93d03891","chunk-2d2172bd":"31d6cfe0","chunk-10b587b9":"5f492552","chunk-2fefc2ba":"3b1cc4df","chunk-375c8d73":"4f501797","chunk-29bebfab":"ef0da253","chunk-2d0a3159":"31d6cfe0","chunk-2d0dd7af":"31d6cfe0","chunk-2d0ddba1":"31d6cfe0","chunk-2d20864f":"31d6cfe0","chunk-2d22b970":"31d6cfe0","chunk-2d21a841":"31d6cfe0","chunk-2d237ffc":"31d6cfe0","chunk-4ef50286":"f5febd62","chunk-4442e952":"04ea624b","chunk-4e69cf76":"097b5913","chunk-50d21eb3":"9f69edb5","chunk-57cc81a2":"37df1425","chunk-5c4c15db":"832f84b9","chunk-00978fa7":"31d6cfe0","chunk-df2ead5c":"31d6cfe0","chunk-08a87dc8":"2d2d56a7","chunk-2d0aa281":"31d6cfe0","chunk-25352464":"92511c68","chunk-2d0ae5d6":"31d6cfe0","chunk-2d0da355":"31d6cfe0","chunk-2d216ba8":"31d6cfe0","chunk-b57fc804":"31d6cfe0","chunk-5cc1684b":"855f9447","chunk-68d1576d":"72998b90","chunk-69505e62":"96e01ab6","chunk-4319630e":"15b9cb31","chunk-348c457e":"d38756b5","chunk-d4a1374e":"a136cfdd","chunk-17829288":"a1a24b77","chunk-46cbb527":"88219f6f","chunk-560cd510":"6a987fdc","chunk-56e47990":"fce8b943","chunk-3d494bb4":"6c22b62d","chunk-2191ace6":"27b555b9","chunk-2751310e":"7e1ecbad","chunk-2d22693c":"31d6cfe0","chunk-7c6c5868":"38603d2c","chunk-f5d0d6bc":"86236e09","chunk-fc733508":"0337171c","chunk-2d22d3f4":"31d6cfe0","chunk-b932986e":"32636ee4","chunk-6f197e96":"99358cdb","chunk-889f54bc":"e1d0fec9","chunk-a9632ad4":"ddb6d2a6","chunk-b815aa6c":"666d41cc","chunk-ddbd689a":"5c5d407e","chunk-26f209f6":"95e6a058","chunk-ecae29fc":"2457469d","chunk-f8432fd6":"2457469d","chunk-ffeae3ca":"332b4a4f","chunk-10d582ee":"91868441","chunk-1d94d3f1":"a140772d","chunk-2d0cc2ee":"31d6cfe0","chunk-3e2e8798":"31d6cfe0","chunk-401d5cd2":"6cb98cce","chunk-2cf0b788":"a97febbf","chunk-e0125934":"367bb202","chunk-0735384e":"05aece20","chunk-743c2ddb":"0dd2478f","chunk-7457c560":"d4ad834b","chunk-745a3122":"d7dc1639","chunk-7467d5b8":"97906909","chunk-7482e5bc":"3fc962f4","chunk-74af77ea":"23b17eb2","chunk-74b7681c":"6ff76692","chunk-74bb0962":"06c127ee","chunk-76f042f8":"a3d504dc","chunk-774c8cf7":"93e9293c","chunk-17a63ea5":"0da95f5b","chunk-2d209b31":"31d6cfe0","chunk-0987dada":"db5d03c5","chunk-6943e552":"b196006c","chunk-80018e16":"8bc269ef","chunk-a1825bbc":"c22f5ac1","chunk-2d2223ef":"31d6cfe0","chunk-2d607d30":"d09cf3eb","chunk-2f83f030":"f2e3d023","chunk-4aad5e3d":"2405960a","chunk-55693694":"2e1a912a","chunk-62fe80ef":"c0261f0b","chunk-71fa889d":"07cc3c21","chunk-7d47e309":"31d6cfe0","chunk-037567df":"d4b79940","chunk-3bafb6c4":"47b392f8","chunk-ad1740b0":"18f5736b","chunk-ba57138a":"c62c4385","chunk-c0f817d4":"7bfbbbb7","chunk-f210cb80":"5da84a9f"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://presenter.ahaslides.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
